import * as React from "react";
import { cn } from "@web-shared/lib/utils";

/**
 * Minimal disclosure. Deliberately not Radix Collapsible: this only ever wraps
 * table rows, where an extra wrapper element would break the table layout.
 */
export function useDisclosure(initial = false) {
  const [open, setOpen] = React.useState(initial);
  return { open, toggle: React.useCallback(() => setOpen((v) => !v), []), setOpen };
}

export function Chevron({ open, className }: { open: boolean; className?: string }) {
  return (
    <svg
      viewBox="0 0 16 16"
      className={cn("size-3.5 shrink-0 transition-transform", open && "rotate-90", className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden
    >
      <path d="M6 3l5 5-5 5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
